import { Component } from '@angular/core';
import { OverlayComponent } from '@overlays/overlay/overlay.component';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-home-play-button',
  templateUrl: './home-play-button.component.html',
  styleUrls: ['./home-play-button.component.scss'],
  imports: [NgStyle],
})
export class HomePlayButtonComponent extends OverlayComponent {
  /**
   * Update the overlay styles based on the viewport size
   */
  override updateOverlayStyles(): void {
    const { playerWidth = 0, playerHeight = 0, browserHeight = 0, browserWidth = 0 } = this.viewportSize || {};

    // Calculate dimensions and position
    let leftPosition: number | string;
    let topPosition: number | string;

    // NOTE: Check if browser height is really big or when the
    // browser winodw is narrow. Adjust the overlay to mat
    // the smaller player height and widths.
    if (browserHeight > browserWidth) {
      leftPosition = Math.floor(playerWidth / 2);
      topPosition = Math.floor(playerHeight / 2);
    } else {
      leftPosition = Math.floor(playerWidth / 2);
      topPosition = Math.floor(playerHeight / 2);
    }

    this.overlayStyles = {
      position: 'absolute',
      top: `${topPosition}px`,
      left: `${leftPosition}px`,
    };
  }
}
